module.exports = __webpack_public_path__ + "static/img/2.08a6a36e.png";